const en = {
	'点击右上角的按钮,选择在浏览器中打开': 'Click here {...} in the right top corner, Choose a browser to open',
	'已为你打开新的页面, 本页面请关闭':'We’ve opened a new window,you can now close this window.',
}
export default en;